export default __webpack_public_path__ + "static/color-picker-backgrounds-light-bbb5597d469d9270b868804d6a04bd13e11fdbc195354fc1905cbd776990b1f8.png";